"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const SuspenseContext_1 = require("../../contexts/SuspenseContext");
const helpers_1 = require("../../lib/helpers");
const SuspenseLoader_1 = __importDefault(require("./SuspenseLoader"));
const SuspenseError_1 = __importDefault(require("./SuspenseError"));
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const SuspenseEmpty_1 = __importDefault(require("./SuspenseEmpty"));
const useSuspenseContext_1 = require("../../hooks/SWR/useSuspenseContext");
const useAddToForwardRef_1 = require("../../hocs/useAddToForwardRef");
/*
 This is a reusable component which handles the logistics of requests
 such as showing a loader, showing an 204 result when needed,
 and showing if any errors occurred during the requests.
 */
const Suspense = (props) => {
    var _a, _b, _c;
    const { children, disableEmpty, style, hook, } = props;
    const hasLoaderComponent = helpers_1.hasChildComponent(props, 'j-suspense-loader');
    const hasErrorComponent = helpers_1.hasChildComponent(props, 'j-suspense-error');
    const hasEmptyComponent = helpers_1.hasChildComponent(props, 'j-suspense-empty');
    const isPaginating = hook.hasOwnProperty('lastFetchedPage');
    let { infiniteScroll } = props;
    if (isPaginating) {
        infiniteScroll = (infiniteScroll !== null && infiniteScroll !== void 0 ? infiniteScroll : {});
        infiniteScroll.position = (_a = infiniteScroll === null || infiniteScroll === void 0 ? void 0 : infiniteScroll.position) !== null && _a !== void 0 ? _a : 'bottom';
        infiniteScroll.maxHeight = (_b = infiniteScroll === null || infiniteScroll === void 0 ? void 0 : infiniteScroll.maxHeight) !== null && _b !== void 0 ? _b : 'min-content';
    }
    const localContainerRef = react_1.useRef(null);
    const containerRef = (_c = props.containerRef) !== null && _c !== void 0 ? _c : localContainerRef;
    let newStyle = Object.assign({}, style);
    if (infiniteScroll && (infiniteScroll === null || infiniteScroll === void 0 ? void 0 : infiniteScroll.maxHeight) !== 'window' && !props.containerRef) {
        newStyle = Object.assign(Object.assign({}, newStyle), { maxHeight: infiniteScroll.maxHeight, overflowY: 'auto' });
    }
    const forwardedRef = useAddToForwardRef_1.useAddToForwardRef(props, [localContainerRef]);
    const contextValue = useSuspenseContext_1.useSuspenseContext(props, containerRef);
    const primitiveProps = helpers_1.usePrimitiveProps(props, { className: classnames_1.default({ 'overflow-hidden': !hook.data }) });
    primitiveProps.ref = forwardedRef;
    return (react_1.default.createElement(SuspenseContext_1.SuspenseContext.Provider, { value: contextValue },
        react_1.default.createElement("div", Object.assign({}, primitiveProps, { style: newStyle }),
            !hasLoaderComponent && (infiniteScroll === null || infiniteScroll === void 0 ? void 0 : infiniteScroll.position) === 'top' && react_1.default.createElement(SuspenseLoader_1.default, null),
            !hasErrorComponent && react_1.default.createElement(SuspenseError_1.default, null),
            !disableEmpty && !hasEmptyComponent && react_1.default.createElement(SuspenseEmpty_1.default, null),
            children,
            !hasLoaderComponent && (infiniteScroll === null || infiniteScroll === void 0 ? void 0 : infiniteScroll.position) === 'bottom' && react_1.default.createElement(SuspenseLoader_1.default, null))));
};
exports.default = withJourney_1.default('j-suspense', Suspense);
